import { useToast } from '@common/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { AuthMutation, AuthQueryKey, UnauthQueryKey } from '@/api';

export const useDeleteCommentMutation = () => {
  const { toastError } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    ...AuthMutation['put:/wello/v2/auth/wello-comment/{welloCommentId}/delete'](),
    meta: {
      reset: [
        AuthQueryKey['get:/wello/v2/auth/wello-comment'](),
        UnauthQueryKey['get:/wello/v2/allows/wello-comment'](),
        AuthQueryKey['get:/wello/v2/auth/wello-comment/my'](),
        AuthQueryKey['get:/wello/v2/auth/community/my'](),
      ],
    },
    onError: (error) => {
      toastError({ error });
    },
    onSuccess: () => {
      //! UnauthQueryOptions로 설정하면 meta.reset에서 잘 작동하지 않음
      queryClient.invalidateQueries({
        queryKey:
          AuthQueryKey['get:/wello/v2/auth/policy/feedback/{policyId}'](),
      });
      queryClient.invalidateQueries({
        queryKey: AuthQueryKey['get:/wello/v2/auth/wello-comment'](),
      });
    },
  });
};
